var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemCondensedMode = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  d: "M19 17a1 1 0 1 1 0 2H5a1 1 0 1 1 0-2zm1-4a1 1 0 1 1 0 2H3l-.103-.005A1 1 0 0 1 3 13zM7 9a1 1 0 0 1 0 2H5a1 1 0 1 1 0-2zm12 0a1 1 0 1 1 0 2h-9l-.103-.005A1 1 0 0 1 10 9zm-5.898-3.995a1 1 0 0 1 0 1.99L13 7H5a1 1 0 0 1 0-2h8zm5 0A1 1 0 0 1 18 7h-2a1 1 0 1 1 0-2h2z"
})));
export default SvgGemCondensedMode;